// ============================================================
// Stimmungsbild lightbox — full-size image popup
// (ERPNext PIT-TASK-2027-000342)
// ============================================================
//
// Stimmungsbilder (Image Only mood images, Website Item.custom_image_only) are
// decorative images between products. Clicking one must NOT open the browser's
// own image view (new tab / native viewer) but an own, pretty overlay:
//   * the image in full size on a dark, blurred backdrop
//   * a transparent, round close button (top right)
//   * closes via the close button, a click on the backdrop and ESC
//   * the page behind keeps its scroll position (body scroll is locked) and
//     the keyboard focus returns to where it was before
//
// Trigger: every mood image carries the class `ws-mood-image` — grid.js,
// list.js, webshop_single.js and macros.html add it. Product images are
// untouched: they keep linking to the product detail page.

webshop.MOOD_IMAGE_CLASS = "ws-mood-image";
webshop.MOOD_IMAGE_SELECTOR = "img." + webshop.MOOD_IMAGE_CLASS;

// Builds and shows the overlay. Kept as a public function so the popup can
// also be opened programmatically (tests/debugging).
webshop.open_image_lightbox = function (src, alt) {
	if (!src) return null;
	// never stack two overlays (double click / click while one is closing)
	webshop.close_image_lightbox();

	const previously_focused = document.activeElement;

	const overlay = document.createElement("div");
	overlay.className = "ws-lightbox";
	overlay.setAttribute("role", "dialog");
	overlay.setAttribute("aria-modal", "true");
	overlay.setAttribute("aria-label", __("Image"));

	const close_btn = document.createElement("button");
	close_btn.type = "button";
	close_btn.className = "ws-lightbox-close";
	close_btn.setAttribute("aria-label", __("Close"));
	close_btn.innerHTML =
		'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
		'stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

	const img = document.createElement("img");
	img.className = "ws-lightbox-img";
	img.alt = alt || "";
	if (alt) img.title = alt;
	img.src = src;

	overlay.appendChild(close_btn);
	overlay.appendChild(img);
	document.body.appendChild(overlay);
	document.body.classList.add("ws-lightbox-open");

	const on_keydown = (event) => {
		if (event.key === "Escape" || event.key === "Esc") {
			event.preventDefault();
			webshop.close_image_lightbox();
		}
	};
	const on_overlay_click = (event) => {
		const on_close_btn = event.target.closest(".ws-lightbox-close");
		// Clicks on the image itself keep it open — only the backdrop closes.
		if (!on_close_btn && event.target.closest(".ws-lightbox-img")) return;
		if (on_close_btn) event.preventDefault();
		webshop.close_image_lightbox();
	};

	overlay.addEventListener("click", on_overlay_click);
	img.addEventListener("load", () => overlay.classList.add("ws-lightbox-loaded"));
	document.addEventListener("keydown", on_keydown);

	// Fade in on the next frame so the CSS transition actually runs.
	requestAnimationFrame(() => overlay.classList.add("ws-lightbox-visible"));

	overlay._ws_close = () => {
		document.removeEventListener("keydown", on_keydown);
		overlay.removeEventListener("click", on_overlay_click);
		document.body.classList.remove("ws-lightbox-open");
		overlay.classList.remove("ws-lightbox-visible");
		if (webshop._lightbox === overlay) webshop._lightbox = null;
		// fade-out, then drop the node
		window.setTimeout(() => overlay.remove(), 200);
		if (previously_focused && previously_focused.focus) {
			try {
				previously_focused.focus();
			} catch (e) {
				// element was re-rendered in the meantime — nothing to restore
			}
		}
	};

	webshop._lightbox = overlay;
	try {
		close_btn.focus();
	} catch (e) {
		// focusing is an enhancement only
	}
	return overlay;
};

webshop.close_image_lightbox = function () {
	const overlay = webshop._lightbox;
	if (!overlay || typeof overlay._ws_close !== "function") return;
	overlay._ws_close();
};

// Delegated trigger: mood images are rendered dynamically (grid/list/single
// re-render on every page change), so the handler sits on the document.
$(document).on("click", webshop.MOOD_IMAGE_SELECTOR, function (event) {
	event.preventDefault();
	event.stopPropagation();
	webshop.open_image_lightbox(this.currentSrc || this.src, this.alt || "");
});

// The mood images are role="button" — keyboard users open the popup with
// Enter or Space, exactly like clicking it.
$(document).on("keydown", webshop.MOOD_IMAGE_SELECTOR, function (event) {
	if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
		event.preventDefault();
		webshop.open_image_lightbox(this.currentSrc || this.src, this.alt || "");
	}
});
